import { ApiProperty } from '@nestjs/swagger';
import { UserStatus, SocialProvider } from '../entities/user.entity';

export class UserResponseDto {
  @ApiProperty()
  id: number;

  @ApiProperty()
  name: string;

  @ApiProperty()
  email: string;

  @ApiProperty({ required: false })
  phone?: string;

  @ApiProperty({ enum: UserStatus })
  status: UserStatus;

  @ApiProperty({ required: false })
  email_verified_at?: Date | null;

  @ApiProperty({ enum: SocialProvider, required: false })
  social_provider?: SocialProvider;

  @ApiProperty({ required: false })
  last_login_at?: Date | null;

  @ApiProperty({ required: false })
  image_url?: string | null;

  @ApiProperty()
  created_at: Date;

  @ApiProperty()
  updated_at: Date;

  @ApiProperty({ required: false })
  access_token?: string;

  @ApiProperty({
    required: false,
    type: () => [UserProgramItemResponseDto],
    description:
      'Programs the user belongs to with the selected type for each program',
  })
  programs?: UserProgramItemResponseDto[];

  @ApiProperty({
    required: false,
    type: () => [UserCategoryItemResponseDto],
    description: 'Categories associated with the user',
  })
  categories?: UserCategoryItemResponseDto[];
}

export class AuthResponseDto {
  @ApiProperty()
  access_token: string;

  @ApiProperty()
  user: UserResponseDto;
}

export class UserProgramItemResponseDto {
  @ApiProperty({ example: 1 })
  program_id: number;

  @ApiProperty({ example: 'Weight Loss' })
  program_name: string;

  @ApiProperty({ example: 2 })
  type_id: number;

  @ApiProperty({ example: 'Beginner' })
  type_name: string;
}

export class UserCategoryItemResponseDto {
  @ApiProperty({ example: 1 })
  id: number;

  @ApiProperty({ example: 'Fitness' })
  name: string;

  @ApiProperty({ example: 'fitness', required: false })
  slug?: string | null;
}
